import { CloudDownloadOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { PdfViewer } from '@medcom/shared-ui/components/PdfViewer/PdfViewer.tsx';
import { Alert, Button, Flex } from 'antd';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useDownloadlabResultAttachment } from '../../../../../api/lab-result.queries.ts';
import { LoadingIndicator } from '../../../../../components/LoadingIndicator.tsx';
import type { LabResultAttachment } from '../../../../../generated/openapi/befunde-api';
import { useLabResultViewStore } from '../../../../../store/useLabResultViewStore.ts';

const download = (objectUrl: string, filename: string) => {
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  a.click();
};

export const LabResultAttachmentRenderer: React.FC<{
  attachment: LabResultAttachment;
}> = ({ attachment }) => {
  const selectedId = useLabResultViewStore(state => state.selectedId);
  const [objectUrl, setObjectUrl] = useState('');
  const isPdf = attachment?.mimeType === 'application/pdf';

  const { data, isLoading, error } = useDownloadlabResultAttachment({
    // biome-ignore lint/style/noNonNullAssertion: should be set
    orderResultId: selectedId!,
    attachmentId: attachment?.id,
  });

  useEffect(() => {
    if (data) {
      setObjectUrl(URL.createObjectURL(new Blob([data], { type: attachment.mimeType })));
    }
  }, [attachment, data]);

  useEffect(() => {
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [objectUrl]);

  if (isLoading) {
    return (
      <Flex
        vertical
        className={css`
          flex-grow: 1;
        `}
      >
        <LoadingIndicator />
      </Flex>
    );
  }

  if (error) {
    console.error('error', attachment, error);
    return <Alert type="warning" description="Der Anhang konnte nicht geladen werden" />;
  }

  if (!objectUrl) {
    return null;
  }

  return (
    <>
      {isPdf && (
        <>
          <PdfViewer src={objectUrl} />
          &nbsp;
        </>
      )}
      <Flex justify="flex-end">
        <Button type="primary" icon={<CloudDownloadOutlined />} onClick={() => download(objectUrl, attachment.filename)}>
          Anhang herunterladen
        </Button>
      </Flex>
    </>
  );
};
